import { Maybe } from '../__generated__/graphql';

export function isDefined<T>(value?: Maybe<T> | undefined): value is T {
  return value !== null && value !== undefined;
}
